import { DatePicker, Input } from "antd";
import dayjs from "dayjs";
import { ListPage } from "../../components/ListPage";
import { DT_FORMATS } from "../../helpers/constants";
import type { AuditLog } from "../../api-models";

const { RangePicker } = DatePicker;

/** The URL carries the range as RFC3339 so the server reads it to the minute. */
const toParam = (v: dayjs.Dayjs | null | undefined) => v?.toISOString() ?? null;
const fromParam = (v: string | undefined) => (v ? dayjs(v) : null);

export default function AuditPage() {
  return (
    <ListPage<AuditLog>
      title="Audit Log"
      endpoint="/audit-logs"
      searchPlaceholder="Search entity or action..."
      // The audit table grows with every write in the system, so its endpoint answers
      // without a COUNT(*) and this list loads more instead of paging (audit.go).
      loadMore
      filters={({ value, set, setMany }) => (
        <>
          <Input
            placeholder="Entity type (e.g. BOM)"
            value={value("entityType") ?? ""}
            onChange={(e) => set("entityType", e.target.value)}
            style={{ width: 200 }}
            allowClear
          />
          <RangePicker
            showTime={{ format: "HH:mm" }}
            format={DT_FORMATS.dateTime}
            placeholder={["From", "To"]}
            value={[fromParam(value("from")), fromParam(value("to"))]}
            // Both ends in one navigation — two `set` calls would not compose.
            onChange={(range) => setMany({ from: toParam(range?.[0]), to: toParam(range?.[1]) })}
          />
        </>
      )}
      columns={[
        { title: "Date", dataIndex: "createdAt", sorter: true, render: (v) => dayjs(v).format(DT_FORMATS.dateTime) },
        { title: "Entity", dataIndex: "entityType", sorter: true },
        { title: "Entity ID", dataIndex: "entityId", sorter: true },
        { title: "Action", dataIndex: "action", sorter: true },
        { title: "Actor", render: (_, r) => r.actor?.name ?? r.actorId },
      ]}
    />
  );
}
